<mc-application-messages #notification class="notification-container" duration-in-ms="10000"></mc-application-messages>

<!-- Save Layer -->
<mc-window #saveLayerWindow id="saveLayerWindow" title="Save Layer" is-draggable="true" is-resizable="true"
           [width]="800" [maxHeight]="800" top="100">
    <mc-save-layer #saveLayer slot="content" enable-folders="true"></mc-save-layer>
</mc-window>

<!-- Save Map -->
<mc-window #saveMapWindow id="saveMapWindow" title="Save Map" is-draggable="true" is-resizable="true" min-width="500"
           min-height="400" top="100">
    <mc-save-map #saveMap slot="content" show-public="false"></mc-save-map>
</mc-window>

<!-- Share Map -->
<mc-window #shareMapWindow id="shareMapWindow" title="Share Map" is-draggable="true" is-resizable="true" min-width="500"
           min-height="400">
    <mc-share-map #shareMap slot="content"></mc-share-map>
</mc-window>

<!-- Unshare Map -->
<mc-window #unshareMapWindow id="unshareMapWindow" title="Unshare Map" is-draggable="true" is-resizable="true"
           min-width="500" min-height="400">
    <mc-unshare-map #unshareMap slot="content"></mc-unshare-map>
</mc-window>

<!-- Filter Layer Options -->
<mc-window #filterLayerOptionsWindow id="filterLayerOptions" title="Filter Layer Options" modal="true" width="600">
    <div slot="content">
        <h4>Select a filter option for each layer.</h4>
        <div *ngFor="let layer of selectedLayers; index as i;" class="selected-layer">
            <span>{{layer.name}}</span>
            <div>
                <div class="fieldset-radio filter-type-picker">
                    <label class="margin-left-1"><input type="radio" [name]="layer" value="showAll" [(ngModel)]="layer.filterType">Show All</label>
                    <label class="margin-left-1"><input type="radio" [name]="layer" value="filter" [(ngModel)]="layer.filterType">Filter</label>
                    <label class="margin-left-1" *ngIf="defaults && defaults.length"><input type="radio" [name]="layer" value="defaults" [(ngModel)]="layer.filterType">User Defaults</label>
                </div>
                <ng-container *ngFor="let extraFilter of layer.extraFilters; index as j;">
                    <div *ngIf="extraFilter.name === 'NOCO_VS_PAYROLL'" class="extra-filter">
                        <p class="text-muted">
                            Default: Payroll Actuals
                            <br />
                            <label class="text-noco"><input type="checkbox" [checked]="extraFilter.value === true" (change)="extraFilter.value = $event.currentTarget.checked ? true : false">Completed NOCO Only</label>
                        </p>
                    </div>
                    <div *ngIf="extraFilter.name === 'SAP_REMAINING_VS_COMPLETED' || extraFilter.name==='PLANYEAR_SEALCOAT'" class="extra-filter">
                        <label class="text-noco" *ngIf="extraFilter.name === 'SAP_REMAINING_VS_COMPLETED'"><input type="checkbox" [checked]="extraFilter.value.remaining === true" (change)="extraFilter.value.remaining = $event.currentTarget.checked ? true : false">Remaining Only (Excludes NOCO)</label>
                        <label class="radio-group-title">Year Type:</label>
                        <input class="radio-group-input" type="radio" [id]="'fy_' + i + j" [name]="'cyfy_' + i + j" value="fy" [(ngModel)]="extraFilter.value.yearType" />
                        <label class="radio-group-label" [for]="'fy_' + i + j">Fiscal</label>
                        <input class="radio-group-input" type="radio" [id]="'cy_' + i + j" [name]="'cyfy_' + i + j" value="cy" [(ngModel)]="extraFilter.value.yearType" />
                        <label class="radio-group-label" [for]="'cy_' + i + j">Calendar</label>
                    </div>
                    <div *ngIf="extraFilter.name === 'SEALCOAT' || extraFilter.name==='PLANYEAR_SEALCOAT'" class="extra-filter">
                        <label class="radio-group-title">Seal Coat:</label>
                        <input class="radio-group-input" type="radio" [id]="'include_' + i" [name]="'sealcoat_' + i" [value]="true" [(ngModel)]="extraFilter.value.sealCoat" />
                        <label class="radio-group-label" [for]="'include_' + i">Include</label>
                        <input class="radio-group-input" type="radio" [id]="'exclude_' + i" [name]="'sealcoat_' + i" [value]="false" [(ngModel)]="extraFilter.value.sealCoat" />
                        <label class="radio-group-label" [for]="'exclude_' + i">Exclude</label>
                    </div>
                    <div *ngIf="extraFilter.name === 'DATERANGE'" class="extra-filter">
                        <label>
                            From:
                            <input type="date" [(ngModel)]="extraFilter.value.from">
                        </label>
                        <label>
                            To:
                            <input type="date" [(ngModel)]="extraFilter.value.to">
                        </label>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="text-right">
            <button class="btn btn-small margin-right-1" (click)="setFilters()">Next</button>
            <button class="btn btn-small margin-right-third" (click)="closeFilterLayerOptionsWindow()">Cancel</button>
        </div>
    </div>
</mc-window>

<!-- Export Layer -->
<mc-window id="exportLayerFilter" title="Export Layer" modal="true" width="600">
    <div slot="content">
        <fieldset class="fieldset-checkbox">
            <legend id="exportLayerLegend"></legend>
            <label *ngFor="let childTable of childTables">
                <input type="checkbox" name="child" value="{{childTable.checked}}" [(ngModel)]="childTable.checked" />
                {{ childTable?.layerChildRelationshipName }}
            </label>
        </fieldset>
        <button class="btn btn-small btn-red" style="float: right;" (click)="closeExportLayerFilterWindow()">Cancel</button>
        <button class="btn btn-small" style="float: right; margin-right: 10px;" (click)="exportLayerWithChildTables()">Ok</button>
    </div>
</mc-window>

<!-- Export Map -->
<mc-window #exportMapWindow title="Export Map" modal="true" width="400">
    <div slot="content">
        <mc-export-map #exportMap></mc-export-map>
    </div>
</mc-window>

<!-- Layer Filter -->
<mc-window #layerFilterWindow id="layerFilterWindow" title="Layer Filter" is-resizable="true" is-draggable="true"
           height="700" width="960">
    <div slot="content">
        <mc-layer-filter-container #layerFilter id="layerFilter"></mc-layer-filter-container>
    </div>
</mc-window>

<!-- Symbol Editor -->
<mc-window #symbolEditorWindow id="symbolEditorWindow" title="Symbol Editor" is-draggable="true" is-resizable="true"
           width="530" top="75" left="300">
    <mc-symbol-editor-container #symbolEditor id="symbolEditor" slot="content">
        <mc-point-symbol-editor slot="point-symbol-editor"></mc-point-symbol-editor>
        <mc-line-symbol-editor slot="line-symbol-editor"></mc-line-symbol-editor>
        <mc-polygon-symbol-editor slot="polygon-symbol-editor"></mc-polygon-symbol-editor>
        <mc-text-symbol-editor slot="text-symbol-editor"></mc-text-symbol-editor>
        <mc-layer-opacity-editor slot="layer-opacity-editor"></mc-layer-opacity-editor>
    </mc-symbol-editor-container>
</mc-window>

<!-- Min Max Scale -->
<mc-window #minMaxScaleWindow id="minMaxScaleWindow" title="Min/Max Scale" is-draggable="true" is-resizable="true" width="580" top="100">
    <mc-min-max-scale #minMaxScale id="minMaxScale" slot="content" (onclose)="closeMinMax()"></mc-min-max-scale>
</mc-window>

<!-- Layer Label -->
<mc-window #layerLabelsWindow id="layerLabelsWindow" title="Layer Labels" is-draggable="true" is-resizable="true" width="580" top="100">
    <mc-layer-labels #layerLabels id="layerLabels" slot="content"></mc-layer-labels>
</mc-window>

<!-- Spatial Query -->
<mc-window #layerSpatialQueryWindow id="layerSpatialQueryWindow" title="Spatial Query" is-draggable="true"
           is-resizable="true" height="700" width="960">
    <mc-layer-spatial-query #layerSpatial id="layerSpatial" slot="content"></mc-layer-spatial-query>
</mc-window>

<mc-export-layer id="exportLayer" #exportLayer style="display:none"></mc-export-layer>

<!-- Import External Map -->
<mc-window #importExternalMapWindow id="importExternalMapWindow" title="Import AGOL Map" modal="true">
    <mc-import-external-map #importExternalMap slot="content"></mc-import-external-map>
</mc-window>

<!-- Theme Editor -->
<mc-window #themeEditorWindow id="themeEditorWindow" title="Theme Editor" is-draggable="true" is-resizable="true"
           height="650px" width="800px">
    <!-- <mc-split-theme-editor #themeEditor slot="content" use-esri-scheme="false"></mc-split-theme-editor> -->
    <mc-theme-editor #themeEditor slot="content" use-esri-scheme="false"></mc-theme-editor>
</mc-window>

<!-- Buffer Tool -->
<mc-window #bufferWindow id="bufferWindow" modal="true">
    <mc-buffer #buffer slot="content"></mc-buffer>
</mc-window>

<!-- Image Gallery -->
<mc-window #imageWindow id="imageWindow" title="Image Gallery" modal="true">
    <mc-gallery #imageGallery id="imageGallery" slot="content"></mc-gallery>
</mc-window>

<!-- Global Filter -->
<mc-window #globalFilterWindow is-resizable="false" is-draggable="true" width="600" top="200" title="Global Filter Editor">
    <mc-global-filter #globalFilter app-name="Maintenance_IQ" slot="content"></mc-global-filter>
</mc-window>

<!-- Record Editor -->
<mc-window #recordEditorWindow is-resizable="true" is-draggable="true" width="600" min-width="600" height="800" min-height="400" top="100" left="300" title="Editor" style="z-index: 10000;">
    <mc-record-editor #recordEditor slot="content"></mc-record-editor>
</mc-window>

<!-- Body -->
<app-nav-menu #navMenu class="block-display flex-shrink" [mapRef]="map" [openVL]="openVL.asObservable()" [openSV]="openSV.asObservable()" (disableIdentify)="disableIdentify($event)"
              (userSettingsChange)="userSettingsChange($event)" (onResetPress)="onResetPress()" (onResetConfirm)="onResetConfirm()" (onShowOverview)="showOverview = $event" (onMapOpened)="mapOpened($event)"
              (openShareMap)="openShareMap($event)" [openShareLayer]="openShareLayer.asObservable()">
</app-nav-menu>

<div class="flex-grow flex-display flex-row flex-height-fix">
    <aside id="legendArea" class="side-nav flex-shrink flex-display flex-col flex-height-fix" aria-role="complementary"
           [ngClass]="{ 'closed': !sideOpen, 'compact': isCompact }">
        <mc-map-info-container #mapInfoContainer id="mapInfoContainer" slot="map-action" class="flex-shrink">
            <div slot="option-menu" class="dropdown js-dropdown">
                <button class="btn btn-transparent dropdown-btn js-dropdown-toggle icon-ui-settings icon-ui-white icon-only-btn"
                        tabindex="0" aria-haspopup="true" aria-expanded="false"></button>
                <nav class="dropdown-menu dropdown-right" role="menu">
                    <button class="dropdown-link btn" role="menuitem" (click)="openImportExternalMapWindow()"><span class="icon-ui-applications"></span> Import AGOL Map</button>
                    <button *ngIf="isLoggedIn" class="dropdown-link btn" role="menuitem" (click)="openSaveMapWindow()"><span class="icon-ui-save"></span> Save Map</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openShareMap()"><span class="icon-ui-share"></span> Share Map</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openSpatialQueryWindow()"><span class="icon-ui-locate"></span> Spatial Query</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openMapPrintWindow()"><span class="icon-ui-printer"></span> Print Map</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openMergeMap()"><span class="icon-ui-collection"></span> Merge Another Map</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openExportMap()"><span class="icon-ui-download"></span> Export Map to Excel</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openAllDataTables()"><span class="icon-ui-table"></span> Open All Data Tables</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openCompactLegend()"><span class="icon-ui-layers"></span> Show Compact Legend</button>
                </nav>
            </div>
        </mc-map-info-container>
        <div class="additional-controls panel panel-blue"
             [ngClass]="{ 'compact': isCompact }">
            <mc-layer-tooltip slot="content"></mc-layer-tooltip>
            <button class="btn btn-transparent icon-ui-filter" role="menuitem" title="Global Filter" (click)="openGlobalFilter($event)">Global Filter</button>
        </div>
        <div class="legend-area flex-grow flex-height-fix scroll">
            <mc-legend class="block-display" #legend slot="legend" show-layer-detail="false" (optionSelectedEvent)="onOptionSelect($event)"
                       (groupOptionSelectedEvent)="groupOptionSelected($event)" (attached)="optionsAttached($event)" (onsymbolchange)="onSymbolChange($event)">
                <div slot="legend-layer-options" class="dropdown js-dropdown">
                    <button class="btn btn-transparent icon-ui-filter filter-option" role="menuitem" title="Filter"></button>
                    <button class="btn btn-transparent dropdown-btn icon-ui-settings layer-options-button" tabindex="0"
                            aria-haspopup="true" aria-expanded="false"></button>
                    <button class="btn btn-transparent icon-ui-close delete-option" role="menuitem"></button>
                    <nav class="dropdown-menu dropdown-right" role="menu">
                        <button class="dropdown-link details" role="menuitem"><span class="icon-ui-description"></span> Details</button>
                        <button class="dropdown-link data-dictionary-option" role="menuitem"><span class="icon-ui-review"></span> Data Dictionary <span class="icon-ui-link-external icon-ui-flush font-size--3"></span></button>
                        <button class="dropdown-link filter-option" role="menuitem"><span class="icon-ui-filter"></span> Filter</button>
                        <button class="dropdown-link data-table-option" role="menuitem"><span class="icon-ui-table"></span> Data Table</button>
                        <button class="dropdown-link zoom-option" role="menuitem"><span class="icon-ui-zoom-in-magnifying-glass"></span> Zoom to Layer</button>
                        <button class="dropdown-link theme-editor-option" role="menuitem"><span class="icon-ui-pie-chart"></span> Theme Editor</button>
                        <button class="dropdown-link spatial spatial-query-option" role="menuitem" *ngIf="isLoggedIn"><span class="icon-ui-locate"></span> Spatial Query</button>
                        <button class="dropdown-link spatial renew-spatial-query-option" role="menuitem" *ngIf="isLoggedIn"><span class="icon-ui-refresh"></span> Renew Spatial Query</button>
                        <button class="dropdown-link buffer-layer-option" role="menuitem"><span class="icon-ui-layers"></span> Buffer Layer</button>
                        <button class="dropdown-link export-excel-option" role="menuitem"><span class="icon-ui-download"></span> Export to Excel</button>
                        <button class="dropdown-link export-shapefile-option" role="menuitem"><span class="icon-ui-download"></span> Export to Shapefile</button>
                        <button class="dropdown-link copy-option" role="menuitem"><span class="icon-ui-duplicate"></span> Copy</button>
                        <button class="dropdown-link save-option" role="menuitem" *ngIf="isLoggedIn"><span class="icon-ui-save"></span> Save</button>
                        <button class="dropdown-link share-option" role="menuitem" *ngIf="isLoggedIn"><span class="icon-ui-share"></span> Share</button>
                        <button class="dropdown-link min-max-option" role="menuitem"><span class="icon-ui-zoom-in-fixed"></span> Min/Max Scale</button>
                        <button class="dropdown-link labels-option" role="menuitem"><span class="icon-ui-blank-map-pin"></span> Labels</button>
                        <button class="dropdown-link add-record-option" role="menuitem"><span class="icon-ui-plus-circled"></span> Add Record</button>
                        <button class="dropdown-link delete-option" role="menuitem"><span class="icon-ui-close"></span> Remove Layer</button>
                    </nav>
                </div>
                <div slot="legend-layer-group-options" style="text-align: right;">
                    <!-- <button class="btn btn-transparent icon-ui-pie-chart split-theme-editor-option" role="menuitem" title="Edit theme"></button> -->
                    <button class="btn btn-transparent icon-ui-close delete-option" role="menuitem"></button>
                </div>
            </mc-legend>
        </div>
        <button class="expander icon-ui-up-down-arrows btn btn-white" [ngClass]="{ 'compact': isCompact }" (click)="sideOpen = !sideOpen;"></button>
    </aside>
    <div class="flex-grow">
        <mc-map id="mc-map" #map center="[-77.6362661695295, 40.92039887644528]" rotate="false" zoom="8" (largerImageRequest)="onLargerImageRequest($event)" (largerVideoRequest)="onLargerVideoRequest($event)">
            <div slot="top-left">
                <mc-extent #extent app-name="Maintenance_IQ"></mc-extent>
                <mc-expander expand-icon-class="esri-icon-basemap" auto-collapse="true" expand-tooltip="Basemap" style="display:block;margin-top: 10px;">
                    <mc-basemap-switcher #basemapSwitcher></mc-basemap-switcher>
                </mc-expander>
            </div>
            <mc-identify #identifyWindow slot="top-right" [showVideologBtn]="true" [showStreetViewBtn]="true" [internal]="isInternal"
                         (bufferFeature)="openFeatureBufferWindow($event)" (openVideologEvent)="openVideolog($event)" (openStreetViewEvent)="openStreetView($event)">
                <div slot="buttons">
                    <button #recordEditorButton class="btn btn-small edit-record-option" (click)="openEditorWindow('edit')">Edit Record</button>
                </div>
            </mc-identify>
            <mc-import-shapefile #importShapefile id="importShapefile" (onfiledrop)="onImportShapefileDrop($event)" (onfiledone)="onImportShapefileDone($event)"></mc-import-shapefile>
            <mc-overview-map [hidden]="!showOverview" slot="bottom-left"></mc-overview-map>
        </mc-map>
    </div>
    <aside class="print-area flex-shrink flex-display flex-col flex-height-fix" aria-role="complementary"
           [ngClass]="{ 'closed': !printOpen, 'ready': printReady }" [ngStyle]="{ 'display': (printActive ? '' : 'none') }">
        <button class="close icon-ui-close btn" (click)="closePrint()" title="Cancel Print"></button>
        <mc-print #print class="flex-grow flex-height-fix scroll"></mc-print>
        <button class="expander icon-ui-up-down-arrows btn btn-white" (click)="toggleCollapsePrintArea()" title="Hide Print"></button>
    </aside>
</div>
<div class="data-table-container" [ngClass]="{ 'closed': dataTableMinimized, 'hidden': !dataTable.opened }">
    <mc-data-table #dataTable autogenerate-column-settings="true" record-editor-enabled="true" max-default-Columns="500" page-size="40" [ngClass]="{ 'closed': dataTableMinimized }">
    </mc-data-table>
    <button class="data-expander icon-ui-up-down-arrows btn btn-white"
            (click)="dataTableMinimized = !dataTableMinimized;"></button>
</div>
<div *ngIf="isLoading" class="loader is-active padding-leader-3 padding-trailer-3">
    <div class="loader-bars"></div>
</div>
